import { cx } from "cva";
import { BuildHtml } from "~/components/BuildHtml";
import { ResponsiveArticleCard } from "~/components/ResponsiveArticleCard";
import { Body, Headline } from "~/ui-library";

export type KeyTakeawaysCardProps = {
  htmlTakeaways: string[];
  className?: string;
};

export const KeyTakeawaysCard = ({
  htmlTakeaways,
  className,
}: KeyTakeawaysCardProps) => (
  <ResponsiveArticleCard
    appearance="primary"
    className={cx(className, "flex flex-col gap-s")}
  >
    <Headline as="h3" blockCase level={6}>
      Key Takeaways
    </Headline>
    <ul className="flex flex-col gap-s pl-m">
      {htmlTakeaways.map((takeawayHtml, index) => (
        <li className="list-disc" key={index}>
          <Body size="large">
            <BuildHtml html={takeawayHtml} />
          </Body>
        </li>
      ))}
    </ul>
  </ResponsiveArticleCard>
);
